<script setup lang="ts">
import { useMMStore } from '@/store/MarvelMachine'
const mmStore = useMMStore()
</script>

<template>
  <div
    class="mavel-machine-deco-sun-light"
    :class="{ spinnning: mmStore.game.isSpinRunning, animationOn: mmStore.game.animationToggle }"
  ></div>
  <div class="mavel-machine-deco-bottle mavel-machine-deco-bottle--1" v-if="!mmStore.breakpoint.isMobile"></div>
  <div class="mavel-machine-deco-bottle mavel-machine-deco-bottle--2" v-if="!mmStore.breakpoint.isMobile"></div>
  <div class="mavel-machine-deco-bottle mavel-machine-deco-bottle--3" v-if="!mmStore.breakpoint.isMobile"></div>
  <div class="mavel-machine-deco-bottle mavel-machine-deco-bottle--4" v-if="!mmStore.breakpoint.isMobile"></div>
</template>

<style lang="scss" scoped>
@keyframes sun-light {
  0% {
    transform: scale(1) rotate(6deg);
    opacity: 1;
  }
  50% {
    transform: scale(1.1) rotate(0deg);
  }
  100% {
    transform: scale(1) rotate(6deg);
  }
}

.mavel-machine-deco-sun-light {
  width: calc(938px * var(--marvel-desktopRatio));
  height: calc(1060px * var(--marvel-desktopRatio));
  top: calc(-487px * var(--marvel-desktopRatio));
  left: calc(40% * var(--marvel-desktopRatio));
  position: absolute;
  background: no-repeat center center / 100% auto;
  transition: all 0.3s;
  background-image: url('@/assets/imgs/mavelmachine/marvelDeco/sunlight.png');
  animation: sun-light 3.5s ease-in-out infinite;
  transform: scale(1);
  z-index: 1;
  &.spinnning.animationOn {
    background-size: 135% auto;
  }
}

.mavel-machine-deco-bottle {
  width: calc(252px * var(--marvel-desktopRatio));
  height: calc(604px * var(--marvel-desktopRatio));
  top: calc(100px * var(--marvel-desktopRatio));
  position: absolute;
  background: url('@/assets/imgs/mavelmachine/marvelDeco/bottles/empty-bottle.png') no-repeat center center / 100% auto;
  &:after {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    content: '';
  }
}

.mavel-machine-deco-bottle--1 {
  top: calc(173px * val(--marvel-desktopRatio));
  left: 50%;
  transform: translateX(calc(-50% - calc(640px * var(--marvel-desktopRatio)))) scale(1.05);
  &:after {
    background: url('@/assets/imgs/mavelmachine/marvelDeco/bottles/bottle-y.png') no-repeat center center / 100% auto;
  }
}

.mavel-machine-deco-bottle--2 {
  left: 50%;
  top: calc(122px * var(--marvel-desktopRatio));
  transform: translateX(calc(-50% - calc(383px * var(--marvel-desktopRatio)))) scale(0.9);
  &:after {
    background: url('@/assets/imgs/mavelmachine/marvelDeco/bottles/bottle-g.png') no-repeat center center / 100% auto;
  }
}

.mavel-machine-deco-bottle--3 {
  right: 50%;
  top: calc(122px * var(--marvel-desktopRatio));
  transform: translateX(calc(50% + calc(383px * var(--marvel-desktopRatio)))) scale(0.9);
  &:after {
    background: url('@/assets/imgs/mavelmachine/marvelDeco/bottles/bottle-p.png') no-repeat center center / 100% auto;
  }
}

.mavel-machine-deco-bottle--4 {
  top: calc(173px * val(--marvel-desktopRatio));
  transform: translateX(calc(50% + calc(630px * var(--marvel-desktopRatio)))) scale(1.05);
  right: 50%;
  &:after {
    background: url('@/assets/imgs/mavelmachine/marvelDeco/bottles/bottle-b.png') no-repeat center center / 100% auto;
  }
}

/* @media #{$tabletForMarvel} {
  .mavel-machine-deco-sun-light {
    right: -20vw;
    left: auto;
  }
} */

@media #{$mobileForMarvel} {
  .mavel-machine-deco-sun-light {
    width: 100vw;
    height: 100vw;
    right: -20vw;
    top: -50vw;
    left: auto;
    transform: scale(1) translateX(-50%);
  }
}
</style>
